export function arrayShallowEquals(array1: Array<any>, array2: Array<any>): boolean {
  return array1.length === array2.length && array1.every((value, index) => value === array2[index]);
}
